import React from "react";
import { string, number } from "prop-types";

/* Minus icon atom component for team card collapse button */
const MinusIcon = ({ color = "#FFFFFF", size = 12 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 12 2" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M0 1H12" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round"
    />
  </svg>
);

MinusIcon.propTypes = {
  color: string,
  size: number
};

export default MinusIcon;

